import { DateInterest, DateRangeSpan } from '../types';

interface AcceptedSpan {
  start: string | null;
  end: string | null;
}

export function acceptedSpan(interest: DateInterest): AcceptedSpan {
  const span: AcceptedSpan = { start: null, end: null };

  for (const range of interest.accept) {
    if (span.start === null || range.from < span.start) span.start = range.from;
    if (span.end === null || range.to > span.end) span.end = range.to;
  }

  return span;
}

export function singleAcceptRange(interest: DateInterest): DateRangeSpan {
  const { start, end } = acceptedSpan(interest);

  return { from: start ?? '', to: end ?? '' };
}

export function collapsesInterest(interest: DateInterest): boolean {
  return (
    interest.accept.length > 1 ||
    interest.exclude.length > 0 ||
    interest.accept.some((range) => range.appointment_days.length > 0)
  );
}
